import { createTheme, ThemeProvider } from "@mui/material";
import { PropsWithChildren, useMemo } from "react";
import { useConfigurationContext } from "@/features/configuration/contexts/configuration-context";

export default function TicketThemeProvider({
    children
}: PropsWithChildren) {
    const { printFont, printFontSize } = useConfigurationContext();

    const theme = useMemo(() => createTheme({
        shape: {
            borderRadius: 0
        },
        palette: {
            action: {
                hover: "rgba(0, 0, 0, 0)"
            },
            text: {
                primary: "black",
                secondary: "black",
                disabled: "black"
            }
        },
        components: {
            MuiPaper: {
                styleOverrides: {
                    root: {
                        borderWidth: "0px"
                    }
                }
            },
            MuiTable: {
                styleOverrides: {
                    root: {
                        overflow: "hidden"
                    }
                }
            },
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        borderWidth: "0px",
                        paddingTop: "3px",
                        paddingBottom: "3px",
                        paddingLeft: 0,
                        paddingRight: "5px"
                    },
                    head: {
                        fontWeight: "normal"
                    }
                }
            }
        },
        typography: {
            allVariants: {
                fontFamily: printFont || `"JetBrains Mono", monospace`,
                fontSize: printFontSize ? `${printFontSize}pt` : "6pt",
                fontWeight: "normal",
                lineHeight: 1.2
            }
        }
    }), [printFont, printFontSize]);

    return <ThemeProvider theme={theme}>
        {children}
    </ThemeProvider>
}